module.exports = __webpack_public_path__ + "img/cooking_hobby.be5030ca.webp";